var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9861 52.9445H48.9624C44.3179 56.7204 38.4074 58.9875 31.9742 58.9875C25.5411 58.9875 19.6306 56.7204 14.9861 52.9445ZM10.2091 47.9246C8.79586 46.0034 7.64025 43.8836 6.77171 41.6239H29.4348V47.9246H10.2091ZM34.4547 47.9246V41.6239H57.1694C56.3009 43.8836 55.1453 45.9961 53.732 47.9246H34.4474H34.4547ZM31.9742 5.02726C46.8499 5.02726 58.9507 17.128 58.9507 32.0037C58.9507 33.5715 58.8108 35.1098 58.5532 36.604H47.6449V23.7525L52.834 18.5633L49.2863 15.0155L45.0834 19.2184L40.9909 15.1259L37.4431 18.6737L42.6323 23.8629V36.604H34.4621V31.275L39.7617 25.9754L36.2139 22.4276L32.011 26.6305L27.9186 22.538L24.3708 26.0858L29.4496 31.1646V36.5967H21.5002V23.7451L26.6894 18.556L23.1416 15.0082L18.9387 19.211L14.8462 15.1186L11.2984 18.6664L16.4876 23.8556V36.5967H5.41737C5.15975 35.1025 5.0199 33.5641 5.0199 31.9963C5.0199 17.1206 17.1206 5.0199 31.9963 5.0199M31.9963 0C14.3236 0 0 14.3236 0 31.9963C0 39.9972 2.93686 47.3063 7.78746 52.9224V52.9371H7.80219C13.6685 59.7162 22.3319 64 32.0037 64C49.6764 64 64 49.6764 64 32.0037C64 14.331 49.6469 0.00736072 31.9742 0.00736072",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.6cbee1353707d711f3c3dcb0b5cf73c5.svg";
export { ForwardRef as ReactComponent };